var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDocumentType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.979,
    height: 15.978,
    viewBox: "0 0 15.979 15.978",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28403",
    "data-name": "Group 28403",
    transform: "translate(-451 -576)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(451 576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47660",
    "data-name": "Path 47660",
    d: "M10,17.5H9.5v2H10a.165.165,0,0,0,.166-.166V17.666A.165.165,0,0,0,10,17.5Z",
    transform: "translate(-3.175 -5.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47661",
    "data-name": "Path 47661",
    d: "M4.833,17.5H4.5v.666h.333a.333.333,0,0,0,0-.666Z",
    transform: "translate(-1.504 -5.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47662",
    "data-name": "Path 47662",
    d: "M12.843,8.009a4.766,4.766,0,0,1-1.691.313A4.827,4.827,0,0,1,7.823,0H1.831A1.83,1.83,0,0,0,0,1.831V14.148a1.83,1.83,0,0,0,1.831,1.831h9.654a1.83,1.83,0,0,0,1.831-1.831V8.482ZM3.329,13.315H3v.832a.5.5,0,1,1-1,0v-3a.5.5,0,0,1,.5-.5h.832a1.332,1.332,0,0,1,0,2.663Zm4.66.166a1.171,1.171,0,0,1-1.165,1.165h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a1.171,1.171,0,0,1,1.165,1.165Zm2.829-1.165a.5.5,0,0,1,0,1H9.654v.832a.5.5,0,1,1-1,0v-2.33A1.166,1.166,0,0,1,9.82,10.652h1a.5.5,0,0,1,0,1h-1a.167.167,0,0,0-.166.166v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47663",
    "data-name": "Path 47663",
    d: "M15,6.991a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,15,6.991Zm0-5.659A2.164,2.164,0,1,0,17.159,3.5,2.166,2.166,0,0,0,15,1.332Z",
    transform: "translate(-3.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47664",
    "data-name": "Path 47664",
    d: "M21.579,10.745a.664.664,0,0,1-.471-.2L18.945,8.386a.666.666,0,1,1,.941-.941L22.05,9.609a.666.666,0,0,1-.471,1.136Z",
    transform: "translate(-6.267 -2.423)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12974",
    "data-name": "Rectangle 12974",
    width: 12,
    height: 6,
    transform: "translate(452 585.174)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDocumentType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_document_type.4c5d031b95bb266f2d099729b4a053b5.svg";